"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ElstrApplicationData_1 = require("./ElstrApplicationData");
/**
 * Retrieve the config.ini value for a public configuration
 * ex: config(supportedLanguages) will return an array of the supported languages
 *
 * returns null when the requested key doesn't exist
 *
 * @param {string} key
 * @return {any}
 */
function config(key) {
    if (ElstrConfig._config[key]) {
        return ElstrConfig._config[key];
    }
    return null;
}
exports.config = config;
/**
 * Stores the initial config delivered at the app initialization
 * and wipes the information
 *
 * Only the public values from the config.ini are promoted to the frontend
 *
 * @class ElstrConfig
 */
var ElstrConfig = /** @class */ (function () {
    function ElstrConfig() {
        if (ElstrApplicationData_1.configExists()) {
            // Delete data from window object
            window.ELSTR.applicationData.config = null;
        }
    }
    ElstrConfig._config = ElstrApplicationData_1.configExists() ? window.ELSTR.applicationData.config : {};
    return ElstrConfig;
}());
exports.default = ElstrConfig;
//# sourceMappingURL=ElstrConfig.js.map